var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coin-line (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Funds---New-Deposit-Praxis---Desktop---Selection",
    transform: "translate(-332.000000, -388.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(292.000000, 388.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin-line-(1)",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,5.33333333 C24.1,5.33333333 30.6666667,8.91466667 30.6666667,13.3333333 L30.6666667,18.6666667 C30.6666667,23.0853333 24.1,26.6666667 16,26.6666667 C8.044,26.6666667 1.568,23.212 1.34,18.9026667 L1.33333333,18.6666667 L1.33333333,13.3333333 C1.33333333,8.91466667 7.9,5.33333333 16,5.33333333 Z M16,21.3333333 C11.04,21.3333333 6.65333333,19.9906667 4,17.9333333 L4,18.6666667 C4,21.176 9.17733333,24 16,24 C22.68,24 27.784,21.2933333 27.9933333,18.824 L28,18.6666667 L28.0013333,17.9333333 C25.348,19.9893333 20.9613333,21.3333333 16,21.3333333 Z M16,8 C9.17733333,8 4,10.824 4,13.3333333 C4,15.8426667 9.17733333,18.6666667 16,18.6666667 C22.8226667,18.6666667 28,15.8426667 28,13.3333333 C28,10.824 22.8226667,8 16,8 Z",
    id: "Shape",
    fill: "#138518",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.1f4788ca.svg";
export { ForwardRef as ReactComponent };